import { CepPipe } from "../pipes/cep-pipe";
import { CpfCnpjPipe } from "../pipes/cpf-cnpj-pipe";

export const SHARED_PIPES = [
    CpfCnpjPipe,
    CepPipe
];

export {
    CpfCnpjPipe,
    CepPipe
}